export default {
    "fsm_settings_break_notifyAt": "Notify at",
    "fsm_settings_break_breakDuration": "Break Duration",
    "fsm_settings_break_contacts": "Contacts",
    "fsm_settings_break_mins": "Mins",
    "FSM_SETTINGS_TIME_CARD_meal_break_notifications": "Meal Break Notifications",
    "FSM_SETTINGS_TIME_CARD_meal_break_success": "Successfully edited Meal Break Notification",
    "fsm_settings_break_error_contacts": "Please select one or more contacts",
    "fsm_settings_break_error_notify": "Please select a Notify At hour"
};